import {Component, inject, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {select, Store} from "@ngrx/store";
import {AppState} from "../../../../store/reducers";
import {selectStoreItems} from "../../../../store/entities/store-item/store-item.selectors";
import {StoreItemEntity} from "../../../../store/entities/store-item/store-item.model";
import {StoreItemActions} from "../../../../store/entities/store-item/store-item.actions";
import {NewsArticle} from "../../../../store/entities/cms/news-article/news-article.model";
import {GET_NEWS_ARTICLES} from "../../../../store/entities/cms/news-article/news-article.graphql";
import {environment} from "../../../../../environments/environment";
import {GET_CAROUSEL_ITEMS} from "../../../../store/entities/cms/carousel-item/carousel-item.graphql";
import {CarouselItem} from "../../../../store/entities/cms/carousel-item/carousel-item.model";

@Component({
  selector: 'app-portal-news-and-slides',
  templateUrl: './portal-news-and-slides.component.html',
  styleUrl: './portal-news-and-slides.component.scss'
})
export class PortalNewsAndSlidesComponent implements OnInit {
  topNews$: Observable<NewsArticle[]>
  carouselItems$: Observable<CarouselItem[]>

  activeCarousel = 0;

  store = inject(Store<AppState>);

  fileUrl = environment.FILE_SERVER_URL;

  onImageLoad(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.classList.remove('opacity-10'); // Make image visible
  }

  ngOnInit() {
    this.topNews$ = this.store.pipe(select(selectStoreItems(StoreItemEntity.newsArticle)))
    this.carouselItems$ = this.store.pipe(select(selectStoreItems(StoreItemEntity.carouselItem)))

    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
      entity: StoreItemEntity.newsArticle,
      query: GET_NEWS_ARTICLES,
      filtering: {
        itemsPerPage: 4
      }
    }))

    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
      entity: StoreItemEntity.carouselItem,
      query: GET_CAROUSEL_ITEMS,
      filtering: {}
    }))


  }

  showSlide(index) {
    return;
    this.activeCarousel = index;
  }

  carouselImages(carouselItems:CarouselItem[]){
    return carouselItems?.map(x=>x?.image);
  }
}
